function initContactForms(root = document) {
	const contactForms = root.getElementsByClassName('contact-form');

	for (var i = 0; i < contactForms.length; i++) {
		let contactForm = contactForms[i];

		if (contactForm.__contactHandlerAttached) continue;
		contactForm.__contactHandlerAttached = true;

		contactForm.addEventListener('submit', function(e) {
		e.preventDefault();
	
		var form = e.target;
		var formFieldset = form.querySelector('fieldset') || form;
	
		if (form.reportValidity() && !form.classList.contains('disabled') && !formFieldset.disabled) {
			
			var formMessageWrapper = form.querySelector('.form-notify');
			var formAction = form.getAttribute('data-action') || '';
			var ajaxUrl = (window.WPURLS && WPURLS.ajaxUrl) ? WPURLS.ajaxUrl + '?action=' + formAction : form.getAttribute('action');
			var formData = [];
			var messageField = form.querySelector('.js-contact-message');
			var company = form.querySelector('[name="company"]');
			var city = form.querySelector('[name="city"]');
			var interestNodes = form.querySelectorAll('[name="interest[]"]:checked');
			var labels = (window.WPURLS && WPURLS.form_labels) ? WPURLS.form_labels : {};
			var formMessage = (window.WPURLS && WPURLS.form_message) ? WPURLS.form_message : {};
			var mailMessage = (window.WPURLS && WPURLS.mail_message) ? WPURLS.mail_message : {};

            formData = new FormData(form);

			if (messageField) {
				var parts = [];
				if (company && company.value) {
					parts.push((labels.company ? labels.company + ': ' : '') + company.value);
				}
				if (city && city.value) {
					parts.push((labels.city ? labels.city + ': ' : '') + city.value);
				}
				if (interestNodes.length) {
					var interests = [];
					interestNodes.forEach(function(node) {
						if (node.value) interests.push(node.value);
					});
					if (interests.length) {
						parts.push((labels.interest ? labels.interest + ': ' : '') + interests.join(', '));
					}
				}
				messageField.value = parts.length ? parts.join(' | ') : (formMessage.default || '');
				formData.set('message', messageField.value);
			}
	
			disableForm(form, formFieldset);
			if (formMessageWrapper) {
				var sendingText = mailMessage.sending || '';
				changeFormMessage(formMessageWrapper, sendingText, 'info');
				showFormMessage(formMessageWrapper);
			}
	
			var xhr = new XMLHttpRequest();
			xhr.open('POST', ajaxUrl, true);
	
			xhr.onreadystatechange = function() {
	
				if (xhr.readyState === 4) {
	
					enableForm(form, formFieldset);
		
					if (xhr.status === 200) {
						var data = JSON.parse(xhr.responseText);

                        
		
						if (data.success) {
	
							if (formMessageWrapper) {
								var successText = data.message ? data.message : (mailMessage.success || '');
								changeFormMessage(formMessageWrapper, successText, 'success');
								showFormMessage(formMessageWrapper);
							}
	
							if (data.redirect) {
								setTimeout(function() {
									window.location.href = data.redirect;
								}, 1000);
							}
	
							resetFormMessage(formMessageWrapper, 20000);
	
						} else {
							if (formMessageWrapper) {
								var errorString = data.message ? data.message : (mailMessage.error || '');
								changeFormMessage(formMessageWrapper, errorString, 'error');
								showFormMessage(formMessageWrapper);
								resetFormMessage(formMessageWrapper);
							}
						}
	
					} else {
						if (formMessageWrapper) {
							var fallbackError = mailMessage.error || '';
							changeFormMessage(formMessageWrapper, fallbackError, 'error');
							showFormMessage(formMessageWrapper);
							resetFormMessage(formMessageWrapper);
						}
	
					}
				}
			};
			
			xhr.send(formData);
	
			e.preventDefault();
		}
	
		}, false);

	}
}

function changeFormMessage(messageWrapper, message, type) {

	messageWrapper.className = 'form-notify ' + type;
	messageWrapper.innerHTML = message;
	messageWrapper.style.display = 'block';

}

function showFormMessage(messageWrapper) {

	if(messageWrapper.style.display !== 'block') {
		messageWrapper.style.display = 'block';
	}

}

function hideFormMessage(messageWrapper) {

	if(messageWrapper.style.display !== 'none') {
		messageWrapper.style.display = 'none';
	}

}

function resetFormMessage(messageWrapper, timeout = 5000) {

	setTimeout(function() {
		changeFormMessage(messageWrapper, '', '');
		hideFormMessage(messageWrapper);
	}, timeout);

}

function disableForm(form, fieldset) {

	fieldset.disabled = true;
	form.classList.add('disabled');
	
}

function enableForm(form, fieldset) {

	fieldset.disabled = false;
	form.classList.remove('disabled');

}

export { initContactForms };
